import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  hakedisRaporuGetir,
  ortakGetir,
  ortakGuncelle,
  ortakNoktaAta,
  ortakNoktaCikar,
  ortakOlustur,
  ortakSil,
  ortaklariListele,
  type HakedisSorgusu,
  type NoktaAtaIstegi,
  type Ortak,
  type OrtakGuncelleIstegi,
  type OrtakOlusturIstegi,
  type SayfalanmisOrtaklar,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useOrtaklar(sayfa: number, boyut = 50) {
  return useQuery<SayfalanmisOrtaklar>({
    queryKey: ['ortaklar', 'liste', sayfa, boyut],
    queryFn: () => ortaklariListele(istemci, sayfa, boyut),
    placeholderData: (o) => o,
  });
}

export function useOrtak(id: string | undefined) {
  return useQuery<Ortak>({
    queryKey: ['ortaklar', 'detay', id ?? ''],
    queryFn: () => ortakGetir(istemci, id as string),
    enabled: !!id,
  });
}

export function useOrtakOlustur() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (g: OrtakOlusturIstegi) => ortakOlustur(istemci, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ortaklar'] }),
  });
}

export function useOrtakGuncelle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...g }: OrtakGuncelleIstegi & { id: string }) =>
      ortakGuncelle(istemci, id, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ortaklar'] }),
  });
}

export function useOrtakSil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => ortakSil(istemci, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ortaklar'] }),
  });
}

export function useOrtakNoktaAta() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ortakId, ...g }: NoktaAtaIstegi & { ortakId: string }) =>
      ortakNoktaAta(istemci, ortakId, g),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ortaklar'] }),
  });
}

export function useOrtakNoktaCikar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ortakId, noktaId }: { ortakId: string; noktaId: string }) =>
      ortakNoktaCikar(istemci, ortakId, noktaId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ortaklar'] }),
  });
}

export function useHakedis(sorgu: HakedisSorgusu | null) {
  return useQuery({
    queryKey: ['ortaklar', 'hakedis', sorgu],
    queryFn: () => hakedisRaporuGetir(istemci, sorgu!),
    enabled: !!sorgu,
  });
}
